import { Form, Select, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

export default function TransferRights({ input }) {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t("Transfer administrative rights")}
      name={input.key}
      rules={[
        {
          required: true,
          message: t("errors::password should not be empty"),
        },
      ]}
    >
      <Tooltip title={t('Feature Unavailable')}>
        <div className="flex-1 flex flex-column">
          <Select
            disabled
            placeholder={t('Select User')}
            size="large"
            type="password"
            className="email" />
        </div>
      </Tooltip>
    </Form.Item>
  )
}
